const C = {
  name: "Tooltip",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 8C10.4523 8 10 8.45228 10 9V10H8V9C8 7.34772 9.34772 6 11 6H13C14.6523 6 16 7.34772 16 9V9.56C16 10.8442 15.1809 11.9984 13.9507 12.4072L13.6899 12.4975L13.6828 12.4998C13.2774 12.6333 13 13.017 13 13.45V14.01H11V13.45C11 12.1658 11.8191 11.0117 13.0493 10.6028L13.3101 10.5125L13.3172 10.5102C13.7226 10.3767 14 9.99304 14 9.56V9C14 8.45228 13.5477 8 13 8H11Z" fill="currentColor"/>
<path d="M13.25 17C13.25 17.6904 12.6904 18.25 12 18.25C11.3096 18.25 10.75 17.6904 10.75 17C10.75 16.3096 11.3096 15.75 12 15.75C12.6904 15.75 13.25 16.3096 13.25 17Z" fill="currentColor"/>
<path d="M1 12C1 5.92772 5.92772 1 12 1C18.0723 1 23 5.92772 23 12C23 18.0723 18.0723 23 12 23C5.92772 23 1 18.0723 1 12ZM12 3C7.03228 3 3 7.03228 3 12C3 16.9677 7.03228 21 12 21C16.9677 21 21 16.9677 21 12C21 7.03228 16.9677 3 12 3Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Tooltip
};
